var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="CDB-Widget-header">\n  <div class="CDB-Widget-title CDB-Widget-contentSpaced">\n    <h3 class="CDB-Widget-textBig" title="' +
__e( title ) +
'">' +
__e( title ) +
'</h3>\n  </div>\n  <dl class="CDB-Widget-info CDB-Widget-textSmaller CDB-Widget-textSmaller--upper u-tSpace">\n    <dt>' +
__e( itemsCount ) +
'</dt><dd class="CDB-Widget-info">rows</dd>\n  </dl>\n</div>\n<div class="CDB-Widget-content CDB-Widget-content--noSidesMargin">\n  <div class="CDB-Widget-listWrapper js-content"></div>\n</div>\n<div class="CDB-Widget-footer js-footer"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/list/content-template.tpl
// module id = 873
// module chunks = 2 3